import React, { useState } from "react";
import "./Success.css";
import { get } from "../../apiService";
import { NavLink, useParams } from "react-router-dom";
import { useEffect } from "react";
import GreenTick from "../../Assets/greentick.png";
import successBanner from "../../Assets/ResponseFolder/Untitled design (2).png";
import { IoCall } from "react-icons/io5";
import { IoMdMail } from "react-icons/io";
import { RiSecurePaymentFill } from "react-icons/ri";
import { Button, Divider } from "antd";
import { FaFilePdf } from "react-icons/fa";
import { FaHome } from "react-icons/fa";
import { FaClipboardList } from "react-icons/fa";

export default function Success() {
  const [getData, setGetData] = useState([]);
  const { orderId } = useParams();

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchData();
    }, 500);

    return () => clearTimeout(dbounce);
  }, []);

  const fetchData = async () => {
    try {
      const response = await get(
        `/orders.php?action=fetch&limit=1&order_id=${orderId}&page=1`
      );
      if (response) {
        console.log("sucess page  response" + JSON.stringify(response));
        setGetData(response.list[0]);
        sessionStorage.clear();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [orderId]);
  return (
    <>
      <div className="response_banner_section">
        <div className="response_banner">
          <img src={successBanner} alt="" />
          <h3>
            Congratulations, <br />
            your order is complete
          </h3>
        </div>

        <div className="orderDetailCard">
          <div className="container">
            <img src={GreenTick} alt="check" />
            <p className="text-center">
              Thank you for order with Sejal Exports India! Your order -{" "}
              <strong>{getData.order_id}</strong> has been successfully
              processed. You’ll receive updates as soon as it ships.
            </p>
            <Button
              href={getData.invoice_link}
              target="_blank"
              className="bg-danger text-white"
              icon={<FaFilePdf />}
              style={{ maxWidth: "200px", margin: "auto" }}
            >
              View Order Detail
            </Button>
            <div className="bookingDetail mb-3">
              <h2>{getData.name}</h2>
              <div className="contact_detail d-sm-flex justify-content-between align-items-center">
                <p className="m-0">
                  <IoCall />
                  &nbsp;{getData.number}
                </p>
                <p className="m-0">
                  <IoMdMail />
                  &nbsp;{getData.user_email}
                </p>
                <p className="m-0" style={{ textTransform: "capitalize" }}>
                  <RiSecurePaymentFill /> &nbsp;{getData.payment_type} Payment
                </p>
              </div>
            </div>
            <div className="paymentDetails">
              <div className="row">
                <div className="col-6">Subtotal</div>
                <div className="col-2">-</div>
                <div className="col-4 d-flex align-items-center justify-content-end">
                  $ {getData.sub_total}
                </div>
              </div>
              <div className="row">
                <div className="col-6">Shipping Charge</div>
                <div className="col-2">-</div>
                <div className="col-4 d-flex align-items-center justify-content-end">
                  $ {getData.shipping_charges}
                </div>
              </div>
              <Divider />
              <div className="row">
                <div className="col-6">Total</div>
                <div className="col-2">-</div>
                <div className="col-4 d-flex align-items-center justify-content-end">
                  $ {getData.total}
                </div>
              </div>
            </div>
            <div className="buttonGroup d-flex align-items-center justify-content-center">
              <NavLink to="/">
                <Button className="bg-success text-white" icon={<FaHome />}>
                  Home
                </Button>
              </NavLink>
              <NavLink to="/profile">
                <Button
                  className="bg-dark text-white"
                  icon={<FaClipboardList />}
                >
                  All Orders
                </Button>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
